<template>
  <div class="card__feedback card-body border-top border-bottom border-medium">
    <!-- Date -->
    <div class="response__date text__feedback-time">
      {{ dateString }}
    </div>

    <!-- User profile -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <BaseUserProfile :user-name="userFullName" :size="'lg'">
        <template slot="name">
          <div class="ml-2">
            <div class="text-dark">
              {{ userFullName }}
            </div>
          </div>
        </template>
      </BaseUserProfile>
    </div>

    <!-- Content -->
    <div class="response__content">
      <div
        v-if="
          postResponse &&
          postResponse.assessment_evaluations &&
          postResponse.assessment_evaluations.length
        "
      >
        <div
          v-for="(assessment_evaluation, index) in postResponse.assessment_evaluations"
          :key="index"
        >
          <hr v-if="index !== 0" />

          <BaseLearningOutcomeAndCriterion
            v-if="assessment_evaluation.criterion"
            :index="`post-responses_${postResponse.id}-criteria_${assessment_evaluation.criterion.id}`"
            head-title="Criteria"
            :title="assessment_evaluation.criterion.title"
            :additional-criterion="assessment_evaluation.criterion"
            :description="assessment_evaluation.criterion.description"
            :pass-criterion="assessment_evaluation.criterion.pass_criterion"
            :not-yet-criterion="assessment_evaluation.criterion.not_yet_criterion"
            :pass="assessment_evaluation.pass"
            class="py-3"
          />
        </div>
      </div>

      <!-- <BaseLearningOutcomeAndCriterion
        v-if="isEvaluatedByLearningOutcome"
        title="Learning outcome"
        :description="learningOutcome.description"
        :pass-criterion="learningOutcome.pass_criterion"
        :not-yet-criterion="learningOutcome.not_yet_criterion"
        :pass="postResponse.assessment_evaluation.pass"
      /> -->

      <!-- Additional criterion -->
      <!-- <div v-if="additionalCriterions.length > 0" class="mt-4">
        <div class="font-weight-bold mb-1 header__title">
          Additional assessment criteria
        </div>

        <BaseLearningOutcomeAndCriterion
          v-for="(additionalCriterion, index) in additionalCriterions"
          :key="index"
          :show-title="false"
          :description="additionalCriterion.description"
          :pass-criterion="additionalCriterion.pass_criterion"
          :not-yet-criterion="additionalCriterion.not_yet_criterion"
          :pass="
            postResponse.assessment_evaluation
              .assessment_additional_evaluations[index].pass
          "
        />
      </div> -->

      <!-- <hr /> -->

      <div v-if="!editFeedback" class="my-4">
        <div class="d-flex justify-content-between">
          <div class="font-weight-bold">Feedback</div>
          <div
            v-if="user && user.id == postResponse.user_id"
            class="icon-edit text-dark"
            @click="onClickEditFeedback"
          >
            <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'edit' }" class="font-size-sm" />
            Edit
          </div>
        </div>
        <div v-safe-html="postResponse.description" class="mt-3 text-pre-wrap" />

        <BaseFilesList :attachments="postResponse.attachments" class="mt-3 file-list__feedback" />
      </div>

      <b-row v-else class="pt-2 mx-1">
        <VueElementLoading :active="isSaving" />

        <b-col class="pr-0 pl-0">
          <BaseInput
            id="response-description"
            v-model="postResponse.description"
            input-type="textarea"
            label="Feedback"
            placeholder="Enter your feedback."
            :is-invalid="submitFail"
            invalid-warning-text="The feedback message is required"
            class="pt-3 container__submission-response"
            @keyupEnter="submit"
          />
        </b-col>
        <b-col cols="1" class="pt-5">
          <BaseFilesUploadButton
            ref="refBaseFileUploadFeedback"
            :key="postResponse.attachments.length"
            class="mr-auto btn__attach-file"
            @add-files="addFiles"
          />

          <base-s3-uploader
            v-show="false"
            id="input-attachments"
            ref="attachmentUploader"
            :reference-meta="{ ...referenceMeta, field: 'attachments' }"
            :disabled="isSaving"
            :is-public="false"
          >
          </base-s3-uploader>
        </b-col>

        <b-col
          v-if="postResponse.attachments && postResponse.attachments.length > 0"
          cols="12 px-0"
        >
          <BaseFilesList
            :attachments="postResponse.attachments"
            enable-delete
            class="pt-2 pb-4"
            @delete-file="deleteFile"
          />
        </b-col>

        <b-col v-if="editFeedback" cols="12" class="mb-3 pl-0">
          <div class="d-flex align-items-center">
            <b-button variant="success" class="btn__submit-response" size="sm" @click="submit">
              Update
            </b-button>
            <b-button variant="link" class="btn-link-dark" size="sm" @click="cancelEditFeedback">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- <BaseFilesList :attachments="postResponse.attachments" class="mt-3" /> -->
  </div>
</template>

<script>
import {
  BaseUserProfile,
  BaseFilesList,
  BaseInput,
  BaseFilesUploadButton
} from '@/components/base-components';
import BaseS3Uploader from '@/components/base-components/BaseS3Uploader';
import { datetimeMixin, notificationMixin } from '@/mixins';
import BaseLearningOutcomeAndCriterion from '@/components/base-components/BaseLearningOutcomeAndCriterion';
import { User, Upload, PostResponse } from '@/models';

export default {
  components: {
    BaseUserProfile,
    BaseFilesList,
    BaseLearningOutcomeAndCriterion,
    BaseInput,
    BaseFilesUploadButton,
    BaseS3Uploader
  },

  mixins: [datetimeMixin, notificationMixin],

  props: {
    postResponse: {
      type: Object,
      default: () => {}
    },

    learningOutcome: {
      type: Object,
      default: () => {}
    },

    additionalCriterions: {
      type: Array,
      default: () => []
    },

    isEvaluatedByLearningOutcome: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      editFeedback: false,
      isSaving: false,
      submitFail: false,
      fileIdsTodelete: [],
      formOldFeedback: {
        description: '',
        attachments: []
      },
      referenceMeta: {
        ref: 'post-response',
        refId: null
      }
    };
  },

  computed: {
    dateString() {
      return `
        ${this.formatedDatetime(this.postResponse.created_at, 'MMM D, YYYY hh:mma ')} 
        ${this.cityTimezone} time`;
    },

    user() {
      return User.query().first();
    },

    userFullName() {
      return `${this.postResponse.user.firstname} ${this.postResponse.user.lastname}`;
    },

    haveFilesToUpload() {
      return this.postResponse.attachments.some((attachment) => !attachment.id);
    }
  },

  mounted() {
    this.initData();
  },

  methods: {
    initData() {
      this.formOldFeedback.description = this.postResponse.description
        ? this.postResponse.description
        : '';

      this.formOldFeedback.attachments = this.postResponse.attachments
        ? [...this.postResponse.attachments]
        : [];
    },
    addFiles(files) {
      this.postResponse.attachments = this.postResponse.attachments.concat(files);

      if (
        this.$refs.refBaseFileUploadFeedback &&
        this.$refs.refBaseFileUploadFeedback.$refs &&
        this.$refs.refBaseFileUploadFeedback.$refs.file
      ) {
        this.$refs.refBaseFileUploadFeedback.$refs.file.value = '';
      }
    },

    deleteFile(index) {
      const file = this.postResponse.attachments[index];
      if (file && file.id) {
        this.fileIdsTodelete.push(file);
        this.postResponse.attachments.splice(index, 1);
      } else {
        this.postResponse.attachments.splice(index, 1);
      }
    },

    onClickEditFeedback() {
      this.editFeedback = !this.editFeedback;
    },

    cancelEditFeedback() {
      this.postResponse.description = this.formOldFeedback.description;
      this.postResponse.attachments = [...this.formOldFeedback.attachments];
      this.fileIdsTodelete = [];
      this.editFeedback = !this.editFeedback;
    },

    async uploadFiles(id, attachments) {
      // let resultUpload = null;
      let uploadedAttachments = [];

      if (this.postResponse.attachments.length > 0) {
        this.$set(this.referenceMeta, 'refId', id);

        this.$refs.attachmentUploader.addFiles(attachments);

        uploadedAttachments = await this.$refs.attachmentUploader.upload();

        // const uploadFileForm = new FormData();
        // uploadFileForm.append("ref", "post-response");
        // uploadFileForm.append("refId", id);
        // uploadFileForm.append("field", "attachments");
        // this.postResponse.attachments.forEach((attachment) =>
        //   uploadFileForm.append("files", attachment)
        // );
        // resultUpload = await Upload.api().upload(uploadFileForm);
        // console.log("upload success:", resultUpload.response);
      }

      if (uploadedAttachments.length) {
        this.$set(this.formOldFeedback, 'attachments', [...uploadedAttachments]);

        PostResponse.update({
          where: id,
          data: { attachments: uploadedAttachments }
        });
      }
    },

    async removeFiles(files) {
      for (const file of files) {
        try {
          await Upload.api().deleteFile(file.id);
        } catch (error) {
          console.error(error);
          throw error;
        }
      }
    },

    async submit() {
      let { description = '', attachments = [], id } = this.postResponse;

      description = description.trim();

      if (!description.length) {
        this.submitFail = true;
        return;
      }

      try {
        this.isSaving = true;

        const body = {
          description
        };
        const resultPostResponse = await PostResponse.api().updatePostResponse(id, body);

        await resultPostResponse.save();

        // delete file if any
        if (this.fileIdsTodelete && this.fileIdsTodelete.length) {
          await this.removeFiles(this.fileIdsTodelete);
        }

        // upload file
        console.log(attachments);

        if (this.haveFilesToUpload && attachments.length) {
          await this.uploadFiles(id, attachments);
        }

        this.formOldFeedback.description = this.postResponse.description;
        this.formOldFeedback.attachments = [...this.postResponse.attachments];
        this.notiSuccess('response', 'updated');
        this.clear();
        this.isSaving = false;

        this.$emit('editSuccess', id);
      } catch (error) {
        console.log('send response fail bruhhhh: ', error);
        this.notiError();

        throw new Error(error);
      }

      this.editFeedback = false;
    },

    clear() {
      this.fileIdsTodelete = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.response__date {
  color: rgba(7, 9, 25, 0.5);
}

.response__content {
  margin-left: 4rem;
}

.icon-edit {
  cursor: pointer;
}

.file-list__feedback {
  margin-left: 3.5rem;
}
</style>
